import { Controller } from "@hotwired/stimulus"

// Zdejmuje `disabled` z pól (targets: input) po potwierdzeniu i chowa własny przycisk (target: trigger).
// Dla pól zablokowanych przed przypadkową edycją, odblokowywanych świadomym kliknięciem (np. kod partnera operatora).
export default class extends Controller {
  static targets = ["input", "trigger"]
  static values = { confirm: String }

  unlock() {
    if (this.hasConfirmValue && this.confirmValue && !window.confirm(this.confirmValue)) return

    this.inputTargets.forEach((input) => { input.disabled = false })
    if (this.hasTriggerTarget) this.triggerTarget.classList.add("hidden")
  }
}
